import React, { useState } from 'react';
import { B } from '../constants';
import { feedback as feedbackAPI } from '../api';

// "💬 Feedback" button + small dialog. Sends a 👍/👎 and/or a message to POST /api/feedback.
export default function FeedbackButton({ context, tripId, destination, className, style }) {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(null);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle');

  const close = () => {
    setOpen(false);
    if (status === 'sent') { setRating(null); setMessage(''); setStatus('idle'); }
  };
  const send = async () => {
    setStatus('sending');
    try {
      await feedbackAPI.send({ context, tripId, destination, rating, message });
      setStatus('sent');
    } catch (e) {
      setStatus('error');
    }
  };
  const canSend = (rating != null || message.trim()) && status !== 'sending';
  const choice = (v, label) => (
    <button
      type="button"
      aria-pressed={rating === v}
      onClick={() => setRating(rating === v ? null : v)}
      style={{
        flex: 1, padding: '10px 8px', borderRadius: 12, cursor: 'pointer', fontWeight: 600, fontSize: 14,
        border: `1.5px solid ${rating === v ? B.forest : '#d5dcd8'}`,
        background: rating === v ? '#e9f4ee' : 'white', color: B.night,
      }}
    >
      {label}
    </button>
  );

  return (
    <>
      <button type="button" className={className} style={style} onClick={() => setOpen(true)}>💬 Feedback</button>
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Send feedback"
          onClick={close}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', color: B.night, borderRadius: 18, padding: 20, width: 'min(420px, 100%)', boxShadow: '0 12px 40px rgba(0,0,0,0.25)', fontFamily: "'Montserrat',sans-serif" }}>
            {status === 'sent' ? (
              <>
                <h3 style={{ margin: '0 0 8px', fontSize: 18 }}>Thanks for the feedback!</h3>
                <p style={{ margin: '0 0 16px', color: B.muted, fontSize: 14 }}>We read every message.</p>
                <button type="button" onClick={close} style={{ width: '100%', padding: 12, borderRadius: 12, border: 'none', background: B.forest, color: 'white', fontWeight: 700, cursor: 'pointer' }}>Close</button>
              </>
            ) : (
              <>
                <h3 style={{ margin: '0 0 12px', fontSize: 18 }}>How is this {context === 'trip' ? 'trip' : 'itinerary'}?</h3>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  {choice(1, '👍 Helpful')}
                  {choice(-1, '👎 Needs work')}
                </div>
                <textarea
                  aria-label="Feedback message"
                  value={message}
                  maxLength={2000}
                  rows={4}
                  placeholder="What should we improve? (optional)"
                  onChange={(e) => setMessage(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', padding: 10, borderRadius: 12, border: '1.5px solid #d5dcd8', fontSize: 16, fontFamily: 'inherit', resize: 'vertical' }}
                />
                {status === 'error' && <div role="alert" style={{ color: '#b42318', fontSize: 13, marginTop: 6 }}>Could not send feedback. Please try again.</div>}
                <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                  <button type="button" onClick={close} style={{ flex: 1, padding: 12, borderRadius: 12, border: '1.5px solid #d5dcd8', background: 'white', color: B.night, fontWeight: 600, cursor: 'pointer' }}>Cancel</button>
                  <button type="button" disabled={!canSend} onClick={send} style={{ flex: 1, padding: 12, borderRadius: 12, border: 'none', background: canSend ? B.forest : '#9bb5a8', color: 'white', fontWeight: 700, cursor: canSend ? 'pointer' : 'default' }}>
                    {status === 'sending' ? 'Sending…' : 'Send'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
